import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import Container from "@material-ui/core/Container/Container";
import Box from "@material-ui/core/Box/Box";
import Copyright from "../elements/Copyright";
import {Styles} from "../../../config/design/styles";
import ScrollToTop from "../elements/ScrollToTop";
import AppHeader from "./components/AppHeader";
import AppSidebar from "./components/AppSidebar";
import {connect} from "trim-redux";
import {withRouter} from 'react-router-dom';
import withWidth from "@material-ui/core/withWidth/withWidth";
import CheckSimulation from "../elements/CheckSimulation";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {defaultVariabls} from "../../../config";

class Layout extends React.Component{
    classes = this.props.classes;

    componentDidMount(){
        let { isAuth,user} = this.props;
        if(user === null){
            this.props.history.push('/login')
        }
        if (isAuth){
            if(user.mobile_confirmed === 0){
                this.props.history.push('/verify-mobile')
            }
            let redirect = localStorage.getItem('redirect');
            if(!!redirect){
                localStorage.removeItem('redirect');
                this.props.history.push(redirect);
            }
            this.setState({
                loading:false
            })
        }else{
            this.setState({
                loading:false
            })
        }
    }
    render(){
        const children = this.props.children;
        return(
            <div className={this.classes.root}>
                <CssBaseline />
                <AppHeader/>
                <AppSidebar/>
                <main className={this.classes.content} id="container">
                    <Container maxWidth="lg" className={this.classes.container} >
                        {
                            children
                        }
                        <Box pt={4}>
                            <Copyright />
                        </Box>
                        <CheckSimulation/>
                        {
                            this.props.global_loading &&
                            <div
                                style={{
                                    position:"fixed",
                                    inset:0,
                                    zIndex:9999999998,
                                    backgroundColor:"rgba(0,0,0,0.4)"
                                }}
                            >
                                <div
                                    style={{
                                        position:"fixed",
                                        left:"50%",
                                        top:"50%",
                                        transform:"translate(-50%,-50%)",
                                        zIndex:9999999999,
                                        backgroundColor:"#fff",
                                        borderRadius:20,
                                        padding:40,
                                        minWidth:150,
                                        boxShadow: 'rgba(0,0,0,.4) 0px 0px 10px 1px',
                                        textAlign:"center"
                                    }}
                                >
                                    <img
                                        style={{maxWidth:150,display:"block",marginBottom:20}}
                                        src={`${defaultVariabls.website}/assets/img/rayanita/rayanita-dark.png`}
                                    />
                                    <CircularProgress
                                        color="primary"

                                    />
                                </div>
                            </div>
                        }
                    </Container>
                </main>
                <ScrollToTop/>
            </div>
        )
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    global_loading:state.global_loading,
    logo:state.logo
});
export default withWidth()(withStyles(Styles)(withRouter(connect(mstp)(Layout))));
